import axios from 'axios';

/** Gateway/timeouts/network blips — do not treat as invalid credentials. */
export function isTransientApiError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') return true;
  const status = error.response?.status;
  return status === 502 || status === 503 || status === 504;
}
